function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { throttleAsyncResult } from '@bowencool/async-utilities';
import React from 'react';
import { createPortal } from 'react-dom';
var ElementsHolder = /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef(function (_props, ref) {
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    elements = _React$useState2[0],
    setElements = _React$useState2[1];
  React.useImperativeHandle(ref, function () {
    return {
      setElements: setElements
    };
  }, []);
  var container = document.querySelector('div[data-print-react-component]');
  if (!container) {
    return null;
  }
  return /*#__PURE__*/createPortal(elements, container);
}));
function ensureContainer() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    className = _ref.className;
  if (!document.querySelector('style[data-print-react-component]')) {
    var style = document.createElement('style');
    style.setAttribute('data-print-react-component', 'true');
    style.innerHTML = ".print-only {\ndisplay: none !important;\n}\n@media print {\nbody > * {\n  display: none !important;\n}\n.printable,\n.print-only {\n  display: block !important;\n}\n}";
    document.head.appendChild(style);
  }
  if (!document.querySelector('div[data-print-react-component]')) {
    var container = document.createElement('div');
    container.setAttribute('data-print-react-component', 'true');
    container.classList.add('print-only');
    if (className) {
      container.classList.add(className);
    }
    document.body.appendChild(container);
  }
}
export function usePrint() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    className = _ref2.className;
  var holderRef = React.useRef(null);
  var printReactNode = React.useMemo(function () {
    return throttleAsyncResult(function (content) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        title = _ref3.title;
      return new Promise(function (resolve) {
        ensureContainer({
          className: className
        });
        /**
         * https://github.com/ant-design/ant-design/issues/23623
         * Sync render blocks React event. Let's make this async.
         */
        setTimeout(function () {
          var _holderRef$current;
          (_holderRef$current = holderRef.current) === null || _holderRef$current === void 0 || _holderRef$current.setElements([content]);
          var originalTitle = document.title;
          if (title) {
            document.title = title;
          }
          window.addEventListener('afterprint', function () {
            var _holderRef$current2;
            (_holderRef$current2 = holderRef.current) === null || _holderRef$current2 === void 0 || _holderRef$current2.setElements([]);
            document.title = originalTitle;
            resolve();
          }, {
            once: true
          });
          setTimeout(function () {
            window.print();
          });
        });
      });
    });
  }, []);
  return {
    holder: /*#__PURE__*/React.createElement(ElementsHolder, {
      key: "context-holder",
      ref: holderRef
    }),
    printReactNode: printReactNode
  };
}